"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subStateMatchHelper = exports.pendingStateMatchHelper = exports.canceledStateMatchHelper = exports.convertAppointment = exports.hasProvider = void 0;
const xstate_1 = require("./constants/xstate");
/**
 * Function that determines whether or not a provider exists and returns a boolean
 *
 * @param {} provider
 * @return boolean
 */
const hasProvider = (provider) => Object.keys(provider).length !== 0;
exports.hasProvider = hasProvider;
/**
 * Function to take a backend appointment and strip it down to only the
 * necessary portions for the machine's context
 *
 * @param responseData The appointment response data in backend format. It contains the appointment and capabilities objects.
 * @returns An object containing appointmentId, appointment, location, and providerId,
 *          to be inserted into the machines context
 */
const convertAppointment = (responseData) => {
    var _a, _b, _c, _d, _e;
    if (!responseData || !responseData.appointment) {
        return {
            appointment: undefined,
            capabilities: undefined,
            appointmentId: undefined
        };
    }
    return {
        appointment: Object.assign({}, responseData.appointment),
        appointmentId: (_a = responseData.appointment) === null || _a === void 0 ? void 0 : _a.appointment_ehr_id,
        capabilities: {
            isCancelEnabled: (_c = (_b = responseData.capabilities) === null || _b === void 0 ? void 0 : _b.cancel) === null || _c === void 0 ? void 0 : _c.enabled,
            isRescheduleEnabled: (_e = (_d = responseData.capabilities) === null || _d === void 0 ? void 0 : _d.reschedule) === null || _e === void 0 ? void 0 : _e.enabled
        }
    };
};
exports.convertAppointment = convertAppointment;
/**
 * Helper function to determine when the state machine is in one of the states reflecting a canceled appointment
 * (`confirmationPage` or `canceledPreviously`)
 *
 * @param state xstate state object
 * @returns boolean Whether the state machine is in a canceled appointment context
 */
const canceledStateMatchHelper = (state) => {
    return (state &&
        (state.matches(xstate_1.states.confirmationPage) ||
            state.matches(xstate_1.states.canceledPreviously)));
};
exports.canceledStateMatchHelper = canceledStateMatchHelper;
/**
 * Helper function to determine when the state machine is in one of the loading states
 * (`appointment` or `provider`) but not in an error state
 *
 * @param state xstate state object
 * @returns boolean Whether the state machine is in a pending context
 */
const pendingStateMatchHelper = (state) => {
    return (state &&
        (state.matches(xstate_1.states.appointment) ||
            state.matches(xstate_1.states.provider) ||
            state.matches(xstate_1.states.initializing)) &&
        !(0, exports.subStateMatchHelper)(xstate_1.states.error, state));
};
exports.pendingStateMatchHelper = pendingStateMatchHelper;
/**
 * Helper function to determine when the state machine is in a given substate
 *
 * @param subState xstate substate (e.g. "@state/CANCEL_DISABLED_PAGE")
 * @param state the entire xstate state object
 * @returns boolean Whether the state machine is in a given substate
 */
const subStateMatchHelper = (subState, state) => {
    return state && Object.values(state.value).includes(subState);
};
exports.subStateMatchHelper = subStateMatchHelper;
//# sourceMappingURL=utils.js.map